import { Range, Record, List, Map } from "immutable";

export const SET_ENTITY_FIELD = "SET_ENTITY_FIELD";
export const SET_SEARCH_FIELD = "SET_SEARCH_FIELD";
export const SET_PAGINATION_PAGE = "SET_PAGINATION_PAGE";

// Standard entities actions
export default function entitiesReducer(state, feature, action) {
  const featureUppercase = feature.toUpperCase();

  const payload = action.payload;

  switch (action.type) {
    case SET_ENTITY_FIELD + "_" + featureUppercase:
      return state.setIn(
        [feature, "entities", payload.uid].concat(payload.name),
        payload.value
      );

    case SET_SEARCH_FIELD + "_" + featureUppercase:
      return state.setIn(
        [feature, "search"].concat(payload.field),
        payload.value
      );

    case SET_PAGINATION_PAGE + "_" + featureUppercase:
      return state.setIn([feature, "meta", "currentPage"], payload.value);

  }

  return state;
}



// WEBPACK FOOTER //
// ./src/common/lib/entitiesReducer.js